import { render } from "./HuggingChatBotSettings.vue?vue&type=template&id=dc8fc91c"
import script from "./HuggingChatBotSettings.vue?vue&type=script&lang=js"
export * from "./HuggingChatBotSettings.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__